export const TICK_TIME = 250
export const PLAYER_TICK_TIME = TICK_TIME - 25
export const TILE_SIZE = 20
// export const TILES_BY_SCREEN = 13
export const TILES_BY_SCREEN = 20

// incorrectly, I set SCALE as a constant which is set at the moment this const is imported into modules.
// since SCALE is dynamic based on screen size, I need to make it a functions to get called every time we need it.
// it turns out that constant is used in 117 lines by 22 files. To avoid replacing all those occurence, I came out with this hack:
// convert SCALE into a functions and overcharche it method toString so all the places where is used lik num + SCALE invokes
// the calculation of scale each time.
/* proof:
  const SCALE = () => 25
  SCALE() // outputs 25
  SCALE // outputs function
  SCALE.toString = SCALE
  5 + SCALE // outputs 30
*/
export const SCALE_RATIO = window.devicePixelRatio
// export const SCALE = () => SCALE_RATIO

// export const SCALE = () => 1
export const SCALE = () => document.querySelector('canvas').width/TILES_BY_SCREEN/TILE_SIZE
export const SCALE_V = () => document.querySelector('canvas').height/11/TILE_SIZE

// export const SCALE = () => Math.round((document.querySelector('canvas').width/TILES_BY_SCREEN * 100 / TILE_SIZE/100)*100)/100
SCALE.toString = SCALE

export const TURNINGS = {
  CW: 'CW',
  CCW: 'CCW',
}

export const CLASS_NAMES = {
  ENEMY: 'Enemy',
  WALL: 'Wall',
  BLOCK: 'Block',
  WOMB: 'Womb', // Abushgidim piece
  TORCH: 'Torch',
  PLAYER: 'Player',
  PILLAR: 'Pillar',
  NPC: 'NPCharacter',
  MUSHROOM: 'Mushroom',
  MOVEABLE: 'Moveable',
  JEWEL: 'Jewel',
  INTERACTIVE: 'Interactive',
  GROUND: 'Ground',
  GAME_OBJECT: 'GameObject',
  FALLABLE: 'Fallable',
  EXPLOSION: 'Explosion',
  EXIT: 'Exit',
  EMPTY: 'Empty',
  DESTROYABLE: 'Destroyable',
  DECO: 'Deco',
  DEBRIS: 'Debris',
  CHARACTER: 'Character',
  BOULDER: 'Boulder',
  BARREL: 'Barrel',
  BASE_OBJECT: 'BaseObject',
}

export const PIXEL_NAME_BG = {
  TRANSPARENT: '00ff00',
  BACKGROUND: '000000',
  BG_TOP: 'ffffff',
  BG_RIGHT: '00cc00',
  BG_BOTTOM: '999999',
  BG_LEFT: '0000cc',
  BG_TOP_RIGHT: '00ff00',
  BG_BOTTOM_RIGHT: '009900',
  BG_BOTTOM_LEFT: '000099',
  BG_TOP_LEFT: '0000ff',
  BG_INSET_TOP_RIGHT: 'cc0000',
  BG_INSET_BOTTOM_RIGHT: '660000',
  BG_INSET_BOTTOM_LEFT: '990000',
  BG_INSET_TOP_LEFT: 'ff0000',
}
export const PIXEL_NAME = {
  EMPTY: '000000',
  PLAYER: 'ff00ff',
  GROUND: '663300',
  BOULDER: '999999',
  PILLAR: '545454',
  WALL: '0000ff',
  ENEMY: 'ff0000',
  JEWEL: 'ffff00',
  BARREL: '00ffff',
  EXPLOSION: 'ffffff',
  INTERACTION: '00ff00',
  MUSHROOM: '9900ff',
  BRO: '22a5f6',
  DWARF: 'f29900',
  EXIT: '00cc00',
  ART: '1d4ee1',
  ART2: '000099',
  HANGING_2: 'd2fca8',
  HANGING_3: '7ea854',
  HANGING_4: '547e2a',
  HANGING_5: '2a5400',
  DEBRIS: 'a82a2a',
  BLOCK: 'dadaff',// fake pixel to create a invisible wall, not
  TORCH: '7e5400'
}

export const DIRS = {
  DOWN: 'ArrowDown',
  UP: 'ArrowUp',
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight',
}
export const BG_PIXEL_TO_TILEMAP_POSITION = {
  [PIXEL_NAME_BG.TRANSPARENT]: 81,
  [PIXEL_NAME_BG.BACKGROUND]: 0,
  [PIXEL_NAME_BG.BG_TOP]: 71,
  [PIXEL_NAME_BG.BG_RIGHT]: 82,
  [PIXEL_NAME_BG.BG_BOTTOM]: 91,
  [PIXEL_NAME_BG.BG_LEFT]: 80,
  [PIXEL_NAME_BG.BG_TOP_RIGHT]: 72,
  [PIXEL_NAME_BG.BG_BOTTOM_RIGHT]: 92,
  [PIXEL_NAME_BG.BG_BOTTOM_LEFT]: 90,
  [PIXEL_NAME_BG.BG_TOP_LEFT]: 70,
  [PIXEL_NAME_BG.BG_INSET_TOP_RIGHT]: 85,
  [PIXEL_NAME_BG.BG_INSET_BOTTOM_RIGHT]: 83,
  [PIXEL_NAME_BG.BG_INSET_BOTTOM_LEFT]: 84,
  [PIXEL_NAME_BG.BG_INSET_TOP_LEFT]: 86,
}
export const PIXEL_TO_TILEMAP_POSITION = {
  [PIXEL_NAME.EMPTY]: 0,
  [PIXEL_NAME.WALL]: 3,
  [PIXEL_NAME.GROUND]: 2,
  [PIXEL_NAME.ART]: 0,
  [PIXEL_NAME.ART2]: 20,
  [PIXEL_NAME.EXIT+'_1']: 18,
  [PIXEL_NAME.EXIT+'_2']: 48,
  [PIXEL_NAME.EXIT+'_3']: 88,
  [PIXEL_NAME.DEBRIS]: 1,
  WORLD_ART: 60,
  calculateGroundTileWithNeighbours: (x, y, data) => {
    const W = (data[x]||[])[y-1] === PIXEL_NAME.GROUND ? 'W' : '-'
    const N = (data[x-1]||[])[y] === PIXEL_NAME.GROUND ? 'N' : '-'
    const E = (data[x]||[])[y+1] === PIXEL_NAME.GROUND ? 'E' : '-'
    const S = (data[x+1]||[])[y] === PIXEL_NAME.GROUND ? 'S' : '-'
    switch(`${N}${E}${S}${W}`) {
      case '----':
        default:
        return 2
      case 'NESW':
        return 51
      case 'N---':
        return 63
      case '-E--':
        return 44
      case '--S-':
        return 43
      case '---W':
        return 46
      case 'NE--':
        return 60
      case '-ES-':
        return 40
      case '--SW':
        return 42
      case 'N--W':
        return 62
      case 'NES-':
        return 50
      case '-ESW':
        return 41
      case 'N-SW':
        return 52
      case 'NE-W':
        return 61
      case 'N-S-':
        return 53
      case '-E-W':
        return 45
    }
  },
  calculateWallTileWithNeighbours: (x, y, data) => {
    const W = (data[x]||[])[y-1] === PIXEL_NAME.WALL || [PIXEL_NAME.ART, PIXEL_NAME.ART2].includes((data[x]||[])[y-1]) || [PIXEL_NAME.HANGING_2, PIXEL_NAME.HANGING_3, PIXEL_NAME.HANGING_4, PIXEL_NAME.HANGING_5, PIXEL_NAME.TORCH].includes((data[x]||[])[y-1]) ? 'W' : '-'
    const N = (data[x-1]||[])[y] === PIXEL_NAME.WALL || [PIXEL_NAME.ART, PIXEL_NAME.ART2].includes((data[x-1]||[])[y]) || [PIXEL_NAME.HANGING_2, PIXEL_NAME.HANGING_3, PIXEL_NAME.HANGING_4, PIXEL_NAME.HANGING_5, PIXEL_NAME.TORCH].includes((data[x-1]||[])[y]) ? 'N' : '-'
    const E = (data[x]||[])[y+1] === PIXEL_NAME.WALL || [PIXEL_NAME.ART, PIXEL_NAME.ART2].includes((data[x]||[])[y+1]) || [PIXEL_NAME.HANGING_2, PIXEL_NAME.HANGING_3, PIXEL_NAME.HANGING_4, PIXEL_NAME.HANGING_5, PIXEL_NAME.TORCH].includes((data[x]||[])[y+1]) ? 'E' : '-'
    const S = (data[x+1]||[])[y] === PIXEL_NAME.WALL || [PIXEL_NAME.ART, PIXEL_NAME.ART2].includes((data[x+1]||[])[y]) || [PIXEL_NAME.HANGING_2, PIXEL_NAME.HANGING_3, PIXEL_NAME.HANGING_4, PIXEL_NAME.HANGING_5, PIXEL_NAME.TORCH].includes((data[x+1]||[])[y]) ? 'S' : '-'
    switch(`${N}${E}${S}${W}`) {
      case '----':
        default:
        return 3
      case 'NESW':
        return 21
      case 'N---':
        return 33
      case '-E--':
        return 14
      case '--S-':
        return 13
      case '---W':
        return 16
      case 'NE--':
        return 30
      case '-ES-':
        return 10
      case '--SW':
        return 12
      case 'N--W':
        return 32
      case 'NES-':
        return 20
      case '-ESW':
        return 11
      case 'N-SW':
        return 22
      case 'NE-W':
        return 31
      case 'N-S-':
        return 23
      case '-E-W':
        return 15
    }
  },
  // Dirt earth
  calculateWallTileWithNeighboursDirtEarth: (x, y, data) => {
    const W = (data[x]||[])[y-1] === PIXEL_NAME.WALL ? 'W' : '-'
    const N = (data[x-1]||[])[y] === PIXEL_NAME.WALL ? 'N' : '-'
    const E = (data[x]||[])[y+1] === PIXEL_NAME.WALL ? 'E' : '-'
    const S = (data[x+1]||[])[y] === PIXEL_NAME.WALL ? 'S' : '-'
    switch(`${N}${E}${S}${W}`) {
      case '----':
        default:
        return 2
      case 'NESW':
        return 51
      case 'N---':
        return 63
      case '-E--':
        return 44
      case '--S-':
        return 43
      case '---W':
        return 46
      case 'NE--':
        return 60
      case '-ES-':
        return 40
      case '--SW':
        return 42
      case 'N--W':
        return 62
      case 'NES-':
        return 50
      case '-ESW':
        return 41
      case 'N-SW':
        return 52
      case 'NE-W':
        return 61
      case 'N-S-':
        return 53
      case '-E-W':
        return 45
    }
  }
}